import { useState } from "react";
import { colors, frames } from "../../../../../Styles";
import NewButton from "../../../../../Components/BaseComponents/newButton";
import { AicoConnection, PageHeader, useAicoConnection } from "../../../../../Components";
import ClearAllTablesModal from "../../../../../Components/ToolsComponents/Modals/clearAllTablesModal";

export default function DataTableActions() {
	const [isClearAllTablesModalOpen, setIsClearAllTablesModalOpen] = useState<boolean>(false);

	const { state: connectionState } = useAicoConnection();

	return (
		<frames.Page_inner>
				<PageHeader topHeader='Device Data Tables' subHeader='Actions' />
			<frames._page_inner_content>
				<frames._grid_topBtns_outer>
					<frames._grid_topBtns_inner style={{ position: "relative", justifyContent: "end" }}>
						<div style={{ position: "absolute", top: "50%", transform: "translateY(-50%)", left: "20px" }}><AicoConnection/></div>
					</frames._grid_topBtns_inner>
					<div style={{ gridArea: "2/1/3/2", border: "5px solid " + colors.greyPrimary, overflow: "hidden", borderRadius: "10px", backgroundColor: colors.greyLightTertiary }}>
						<NewButton
							content={"Clear All Tables"}
							disabled={!connectionState.deviceConnection}
							onClick={() => {
								setIsClearAllTablesModalOpen(true);
							}}
						/>
					</div>
				</frames._grid_topBtns_outer>
			</frames._page_inner_content>
			{connectionState.deviceConnection &&
				<ClearAllTablesModal
					isModalOpen={isClearAllTablesModalOpen}
					closeModal={() => { setIsClearAllTablesModalOpen(false) }}
				/>
			}
		</frames.Page_inner>
	)
}